module.exports = __webpack_public_path__ + "d891d13f19b3e48200996fbb49b2686f.svg";